export default {"src":"/_next/static/image/public/images/ic_pom_product_icon.a00189a2fc76c5c025be5e04eb041f7d.svg","height":24,"width":25};